import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';

const SECTIONS = [
  { id: 'institutions', label: 'Institutions' },
  { id: 'commercants',  label: 'Commerçants' },
  { id: 'entreprises',  label: 'Entreprises' },
  { id: 'particuliers', label: 'Particuliers' },
  { id: 'partenaires',  label: 'Partenaires' },
];

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const navigate = useNavigate();

  // Détecte la section visible à l'écran
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
    );

    SECTIONS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const goHome = (anchor) => {
    setMobileMenuOpen(false);
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(anchor);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <nav className="bg-white fixed w-full top-0 z-50 nav-shadow">
      <div className="navbar-inner">
        <div className="navbar-row">
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img src="/assets/icons/logo-variant.svg" alt="Wellywork" className="h-10" />
          </Link>

          {/* Desktop */}
          <div className="hidden md:flex items-center space-x-8">
            {SECTIONS.map(({ id, label }) => (
              <button
                key={id}
                onClick={() => goHome(id)}
                className={`nav-link bg-transparent border-none cursor-pointer${activeSection === id ? ' nav-link-active' : ''}`}
              >
                {label}
              </button>
            ))}
            <Link to="/actualites" className="nav-link" style={{background:'none',border:'none',cursor:'pointer',fontFamily:'inherit',fontSize:'inherit'}}>Actualités</Link>
            <Link to="/espace-commercant" className="btn-outline flex items-center gap-2">
              Espace commerçant
              <ChevronRight size={18} />
            </Link>
          </div>

          {/* Burger */}
          <div className="md:hidden">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-gray-100 mt-2">
            {SECTIONS.map(({ id, label }) => (
              <button
                key={id}
                onClick={() => goHome(id)}
                className={`block py-3 nav-link bg-transparent border-none w-full text-left cursor-pointer${activeSection === id ? ' nav-link-active' : ''}`}
              >
                {label}
              </button>
            ))}
            <Link to="/actualites" onClick={() => setMobileMenuOpen(false)} className="block py-3 nav-link">Actualités</Link>
            <Link
              to="/espace-commercant"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-3 nav-link font-semibold"
              style={{ color: 'var(--primary)' }}
            >
              Espace commerçant →
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
